import React from "react";

import "./index.scss";

const GaugeHigh = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="76" height="33" viewBox="0 0 76 33">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_566" data-name="Rectangle 566" className="cls-1-high" width="60" height="30" />
      </clipPath>
    </defs>
    <g id="Group_13153" data-name="Group 13153" transform="translate(-3 -5)">
      <g id="Guage_Miniature_Graph_1" data-name="Guage Miniature Graph 1" className="cls-2-high" transform="translate(10 7)">
        <path id="Path_9007" data-name="Path 9007" className="cls-3-high" d="M60,30A30,30,0,0,0,45,4.019l-4.5,7.794A21,21,0,0,1,51,30Z" />
        <path id="Path_9008" data-name="Path 9008" className="cls-4-high" d="M45,4.019a30,30,0,0,0-30,0l4.5,7.794a21,21,0,0,1,21,0Z" />
        <path id="Path_9009" data-name="Path 9009" className="cls-4-high" d="M15,4.019A30,30,0,0,0,0,30H9A21,21,0,0,1,19.5,11.814Z" />
      </g>
      <text id="LL" className="cls-5-high" transform="translate(7 36)">
        <tspan x="-3.201" y="0">
          LL
        </tspan>
      </text>
      <text id="HH" className="cls-5-high" transform="translate(74 36)">
        <tspan x="-4.296" y="0">
          HH
        </tspan>
      </text>
      <text id="H" className="cls-5-high" transform="translate(57 10)">
        <tspan x="-2.148" y="0">
          H
        </tspan>
      </text>
      <text id="L" className="cls-5-high" transform="translate(23 10)">
        <tspan x="-1.626" y="0">
          L
        </tspan>
      </text>
    </g>
  </svg>
);

export default GaugeHigh;
